import React, { useState, useRef, useEffect } from "react";
import Skeleton from "react-loading-skeleton";

const FILTER_SKELETON_TABS = 4;

function BranchesFilter({
  tabs = [],
  loading = false,
  activeColor = "#94C23C",
  inactiveColor = "#1414140A",
  activeBadgeBg = "#182A4F",
  onTabChange,
}) {
  const [activeId, setActiveId] = useState(tabs[0]?.id);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const activeTab = tabs.find((t) => t.id === activeId);

  const handleClick = (tab) => {
    setActiveId(tab.id);
    setDropdownOpen(false);
    onTabChange?.(tab);
  };

  // Close dropdown on outside click
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  if (loading) {
    return (
      <div className="branches-filter">
        <ul className="nav nav-tabs d-none d-md-flex" role="tablist">
          {Array.from({ length: FILTER_SKELETON_TABS }).map((_, index) => (
            <li key={`filter-skeleton-${index}`} className="nav-item" role="presentation">
              <Skeleton height={44} width={140} borderRadius={22} />
            </li>
          ))}
        </ul>

        <div
          className="d-flex d-md-none branches-filter-dropdown"
          style={{ justifyContent: "center", marginBottom: "20px" }}
        >
          <Skeleton height={44} width={200} borderRadius={22} />
        </div>
      </div>
    );
  }

  return (
    <div className="branches-filter">

      {/* ── Desktop: tabs (hidden on mobile) ── */}
      <ul className="nav nav-tabs d-none d-md-flex" id="myTab" role="tablist">
        {tabs.map((tab) => {
          const isActive = tab.id === activeId;
          return (
            <li key={tab.id} className="nav-item FS20FW500" role="presentation">
              <button
                className={`nav-link${isActive ? " active" : ""}`}
                id={`${tab.id}-tab`}
                data-bs-toggle="tab"
                data-bs-target={`#${tab.id}-tab-pane`}
                type="button"
                role="tab"
                aria-controls={`${tab.id}-tab-pane`}
                aria-selected={isActive}
                style={{
                  background: isActive ? activeColor : inactiveColor,
                  color: isActive ? "#fff" : "#686868",
                }}
                onClick={() => handleClick(tab)}
              >
                {tab.label}
                <span
                  className="branch-count FS12 fw-600"
                  style={{
                    background: isActive ? activeBadgeBg : "#68686833",
                    color: isActive ? "#fff" : "#686868",
                  }}
                >
                  {tab.count}
                </span>
              </button>
            </li>
          );
        })}
      </ul>

      {/* ── Mobile: dropdown (hidden on desktop) ── */}
      <div
        className="d-flex d-md-none branches-filter-dropdown"
        ref={dropdownRef}
        style={{ position: "relative", width: "100%",justifyContent:"center",marginBottom:"20px" }}
      >
        {/* Trigger button — shows active tab */}
        <button
          type="button"
          onClick={() => setDropdownOpen((prev) => !prev)}
          style={{
            // width: "100%",
            background: activeColor,
            color: "#fff",
            border: "none",
            borderRadius: "22px",
            padding: "10px 19px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            fontWeight: 600,
            fontSize: "16px",
            cursor: "pointer",
            gap:"4px"
          }}
        >
          <span style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            {activeTab?.label}
            <span
              className="branch-count FS12 fw-600"
              style={{
                background: activeBadgeBg,
                color: "#fff",
                borderRadius: "20px",
                padding: "2px 8px",
                fontSize: "12px",
              }}
            >
              {activeTab?.count}
            </span>
          </span>

          {/* Chevron icon */}
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#fff"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
              transition: "transform 0.2s",
              transform: dropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
            }}
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>

        {/* Dropdown menu */}
        {dropdownOpen && (
          <ul
            style={{
              position: "absolute",
              top: "calc(100% + 6px)",
              left: 0,
              right: 0,
              background: "#fff",
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              listStyle: "none",
              margin: 0,
              padding: "6px 0",
              zIndex: 999,
              boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
            }}
          >
            {tabs.map((tab) => {
              const isActive = tab.id === activeId;
              return (
                <li key={tab.id}>
                  <button
                    type="button"
                    onClick={() => handleClick(tab)}
                    style={{
                      width: "100%",
                      background: isActive ? `${activeColor}18` : "transparent",
                      color: isActive ? activeColor : "#686868",
                      border: "none",
                      padding: "10px 16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      fontWeight: isActive ? 700 : 500,
                      fontSize: "15px",
                      cursor: "pointer",
                      textAlign: "left",
                    }}
                  >
                    <span>{tab.label}</span>
                    <span
                      style={{
                        background: isActive ? activeBadgeBg : "#68686833",
                        color: isActive ? "#fff" : "#686868",
                        borderRadius: "20px",
                        padding: "2px 8px",
                        fontSize: "12px",
                        fontWeight: 600,
                      }}
                    >
                      {tab.count}
                    </span>
                  </button>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}

export default BranchesFilter;